'use strict';

Object.defineProperty(exports, "__esModule", {
  value: !0
});

function h(a) {
  return a && "object" === typeof a && "default" in a ? a["default"] : a;
}

var l = h(require("@babel/runtime/helpers/objectWithoutProperties"));

require("@babel/runtime/helpers/objectSpread");

require("@babel/runtime/helpers/slicedToArray");

var m = h(require("@babel/runtime/helpers/typeof"));

function n(a) {
  return "function" === typeof a;
}

function p(a) {
  var b = new Intl.DateTimeFormat(a, 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {});
  return function (a) {
    "string" === typeof a && (a = new Date(a));
    return b.format(a);
  };
}

function q(a) {
  var b = new Intl.NumberFormat(a, 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {});
  return function (a) {
    return b.format(a);
  };
}

function r(a, b) {
  function c(a, c) {
    return function (d) {
      d = n(c) ? c(d) : c;
      d = Array.isArray(d) ? d : [d];
      var v = new Intl.NumberFormat(b).format(a);
      return d.map(function (a) {
        return "string" === typeof a ? a.replace("#", v) : a;
      });
    };
  }

  function e(a) {
    return "string" === typeof a ? g[a] || {
      style: a
    } : a;
  }

  var f = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {},
      g = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : {};
  b = b || a;
  var k = f.plurals;
  return {
    plural: function plural(a, b) {
      var d = b.offset;
      d = void 0 === d ? 0 : d;
      b = l(b, ["offset"]);
      b = b[a] || b[k(a - d)];
      return c(a - d, b);
    },
    selectordinal: function selectordinal(a, b) {
      var d = b.offset;
      d = void 0 === d ? 0 : d;
      b = l(b, ["offset"]);
      b = b[a] || b[k(a - d, !0)];
      return c(a - d, b);
    },
    select: function select(a, b) {
      return b[a] || b.other;
    },
    number: function number(a, c) {
      return q(b, e(c))(a);
    },
    date: function date(a, c) {
      return p(b, e(c))(a);
    },
    undefined: function undefined(a) {
      return a;
    }
  };
}

function t(a) {
  var b = a.values,
      c = r(a.locale, a.locales, a.localeData, a.formats);
  return function d(a, g, k) {
    a = c[g](b[a], k);
    a = n(a) ? a(d) : a;
    return Array.isArray(a) ? a.join("") : a;
  };
}

function u(a, b, c, e) {
  return function (f) {
    var g = a(t({
      locale: b,
      locales: c,
      localeData: e,
      formats: 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
      values: f
    }));
    return Array.isArray(g) ? g.join("").trim() : g;
  };
}

function w() {
  this._catalogs = {};
  this._didActivate = [];
  this._willActivate = [];
}

w.prototype = {
  get availableLocales() {
    return Object.keys(this._catalogs);
  },

  get locale() {
    return this._locale;
  },

  get locales() {
    return this._locales;
  },

  get catalog() {
    return this._catalogs[this.locale];
  },

  get messages() {
    return this.catalog && this.catalog.messages ? this.catalog.messages : {};
  },

  get localeData() {
    return this.catalog.localeData;
  },

  loadAll: function loadAll(a) {
    var b = this;
    Object.keys(a).forEach(function (c) {
      return b.load(c, a[c]);
    });
  },
  load: function load(a, b) {
    var c = this;
    if (!b) return Promise.all(this._willActivate.map(function (b) {
      return b(a).then(function (b) {
        return c.load(a, b);
      });
    }));
    void 0 === this._catalogs[a] && (this._catalogs[a] = {
      messages: {},
      localeData: {}
    });
    var e = this._catalogs[a];
    Object.assign(e.messages, b.messages);
    Object.assign(e.localeData, b.localeData);
    return Promise.resolve();
  },
  activate: function activate(a, b) {
    var c = this;
    if (!this._catalogs[a] && this._willActivate.length) return this.load(a).then(function () {
      return c.activate(a, b);
    });
    this._locale = a;
    this._locales = b;

    this._didActivate.forEach(function (a) {
      return a();
    });

    return Promise.resolve();
  },
  use: function use(a, b) {
    var c = x();
    c._catalogs = this._catalogs;
    c.activate(a, b);
    return c;
  },
  willActivate: function willActivate(a) {
    var b = this;

    this._willActivate.push(a);

    return function () {
      return b._willActivate.filter(function (b) {
        return b !== a;
      });
    };
  },
  didActivate: function didActivate(a) {
    var b = this;

    this._didActivate.push(a);

    return function () {
      return b._didActivate.filter(function (b) {
        return b !== a;
      });
    };
  },
  _: function _(a) {
    var b = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
        c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {},
        e = c.defaults;
    c = c.formats;
    c = void 0 === c ? {} : c;
    a && "object" === m(a) && (b = a.values, e = a.defaults, c = a.formats, a = a.id);
    e = this.messages[a] || e || a;
    var f = this._missing;
    return f && !this.messages[a] ? n(f) ? f(this.locale, a) : f : n(e) ? u(e, this.locale, this.locales, this.localeData)(b, c) : e;
  },
  date: function date(a, b) {
    return p(this.locales || this.locale, b)(a);
  },
  number: function number(a, b) {
    return q(this.locales || this.locale, b)(a);
  }
};

function x() {
  var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
      b = new w();
  a.catalogs && b.loadAll(a.catalogs);
  a.locale && b.activate(a.locale, a.locales);
  a.missing && (b._missing = a.missing);
  return b;
}

exports.setupI18n = x;
exports.date = p;
exports.number = q;